export enum ExportType {
    CSV,
    JSON
}
